import { LanguageCode } from '@kouto/types';

const chineseLocaleMap: Record<string, LanguageCode> = {
  'zh-CN': LanguageCode.ZH_HANS,
  'zh-SG': LanguageCode.ZH_HANS,
  'zh-TW': LanguageCode.ZH_HANT,
  'zh-HK': LanguageCode.ZH_HANT,
  'zh-MO': LanguageCode.ZH_HANT,
};

// Arabic regional variants all map to ar-SA — Modern Standard Arabic is the
// shared written form across the Arab world, so a single translation set
// covers UAE, Saudi Arabia, Egypt, etc.
const arabicLocaleMap: Record<string, LanguageCode> = {
  'ar-AE': LanguageCode.AR_SA,
  'ar-BH': LanguageCode.AR_SA,
  'ar-DZ': LanguageCode.AR_SA,
  'ar-EG': LanguageCode.AR_SA,
  'ar-JO': LanguageCode.AR_SA,
  'ar-KW': LanguageCode.AR_SA,
  'ar-LB': LanguageCode.AR_SA,
  'ar-MA': LanguageCode.AR_SA,
  'ar-OM': LanguageCode.AR_SA,
  'ar-QA': LanguageCode.AR_SA,
  'ar-SY': LanguageCode.AR_SA,
  'ar-TN': LanguageCode.AR_SA,
};

const checkForSupportedLanguageCode = (
  languageCode: string,
): LanguageCode | undefined => {
  if (chineseLocaleMap[languageCode]) {
    return chineseLocaleMap[languageCode];
  }
  if (arabicLocaleMap[languageCode]) {
    return arabicLocaleMap[languageCode];
  }
  return Object.values(LanguageCode).find(
    (code) => code === languageCode || code.startsWith(`${languageCode}`),
  );
};

export default checkForSupportedLanguageCode;
